import React from 'react';
import PropTypes from 'prop-types';
import DatePickerComponent, { registerLocale } from 'react-datepicker';
import fr from 'date-fns/locale/fr';
import { parse, toDate, isValid } from 'date-fns';
import { getIn } from 'formik';
import 'react-datepicker/dist/react-datepicker.css';
import { withDatePicker } from './withDatePicker';
import withLabel from '../Label';

registerLocale('fr', fr);

export const Datepicker = ({
  formik: { values, setFieldValue, setFieldTouched },
  dateFormat,
  disabled,
  name,
  id,
  placeholder,
  onFocus,
  onBlur,
  locale,
  selected,
  ...rest
}) => {
  const [handleChangeRaw, handleChange] = withDatePicker(setFieldValue, setFieldTouched, name, dateFormat);
  const parseDate = () => {
    try {
      const data = getIn(values, name) || values[name];
      return data ? parse(data, dateFormat, new Date()) : undefined;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      return new Date();
    }
  };
  const value = parseDate();
  const validateDate = dirtyDate => {
    try {
      const originalDate = toDate(dirtyDate);
      if (!isValid(originalDate)) {
        return new Date();
      }
      return dirtyDate;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      return new Date();
    }
  };
  return (
    <DatePickerComponent
      {...rest}
      id={id || name}
      name={name}
      selected={validateDate(value) || validateDate(selected)}
      placeholderText={placeholder || dateFormat.toUpperCase()}
      dateFormat={dateFormat}
      disabledKeyboardNavigation={false}
      autoComplete="off"
      onChangeRaw={handleChangeRaw}
      onChange={handleChange}
      onFocus={onFocus}
      onBlur={onBlur}
      disabled={disabled}
      locale={locale}
      peekNextMonth
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
    />
  );
};

Datepicker.propTypes = {
  /** @ignore */
  formik: PropTypes.instanceOf(Object).isRequired,
  /** @ignore */
  onFocus: PropTypes.func.isRequired,
  /** @ignore */
  onBlur: PropTypes.func.isRequired,
  /** Sets the Name of the Datepicker Field */
  name: PropTypes.string.isRequired,
  /** Sets an Id for the Datepicker, if not passed, the id will be the name */
  id: PropTypes.string,
  /** Adds a custom class to the Datepicker wrapper div */
  className: PropTypes.string,
  /** Adds a custom inline styles to the Datepicker wrapper div */
  style: PropTypes.instanceOf(Object),
  /** Sets the main Label for the Datepicker */
  label: PropTypes.string,
  /** Sets a hint text after/below the Datepicker */
  hint: PropTypes.string,
  /**  Sets the desired date format */
  dateFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  /** Sets the Placeholder text */
  placeholder: PropTypes.string,
  /** Sets the Datepicker as requierd, if label is passed, an * is added to the end of the main label. Validation will only work if you pass the required() method in the yup validation schema */
  required: PropTypes.bool,
  /** Disables the Datepicker Field */
  disabled: PropTypes.bool,
  locale: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  selected: PropTypes.object,
};

Datepicker.defaultProps = {
  id: null,
  className: null,
  style: null,
  label: null,
  hint: null,
  dateFormat: 'dd/MM/yyyy',
  placeholder: null,
  required: false,
  disabled: false,
  locale: 'fr',
  selected: null,
};
export default withLabel('datePicker')(Datepicker);
